<template>
    <div class="vote" v-loading='proloading'>
        <div class="add_tits" ref="titles">
            <el-form class="form-inlines u-f " :inline="true">
                <el-form-item>
                    <el-date-picker v-model="formData.fwtimes" class="pd_lf" value-format="yyyy-MM-dd"
                        @change="getbegin" type="daterange" size="small" range-separator="至" start-placeholder="开始日期"
                        end-placeholder="结束日期" :clearable="false">
                    </el-date-picker>
                </el-form-item>
                <el-form-item>
                    <el-select v-model="formData.xwval" clearable filterable placeholder="请选择行为" size="small"
                        @change="getbegin">
                        <el-option v-for="item in formData.xw_options" :key="item.id" :label="item.behavior"
                            :value="item.id">
                        </el-option>
                    </el-select>
                </el-form-item>

            </el-form>
        </div>
        <el-table :data="tableData" border v-loading="loading" :height="height" class="tableLimit votebox">
            <el-table-column prop="create_time" label="时间" align="center" show-overflow-tooltip>
            </el-table-column>
            <el-table-column prop="ip_province" label="省份" align="center"></el-table-column>
            <el-table-column prop="modular_id_text" label="模块" align="center"></el-table-column>
            <el-table-column prop="behavior_id_text" label="行为" align="center"></el-table-column>
            <el-table-column prop="source_url" label="来源页面" align="center" show-overflow-tooltip>
            </el-table-column>
            <el-table-column prop="url" label="前往页面" align="center" show-overflow-tooltip>
            </el-table-column>
            <el-table-column prop="duration" label="停留时间" align="center"></el-table-column>
            <el-table-column prop="username" label="操作人" align="center" show-overflow-tooltip>
            </el-table-column>
        </el-table>
        <div class="u-f u-ac u-jsb ft_mr">
            <div></div>
            <div>
                <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
                    :current-page="currentPage" :page-sizes="[10, 30, 50, 100]" :page-size="pagesize"
                    layout="total, sizes, prev, pager, next, jumper" :total="count">
                </el-pagination>
            </div>
        </div>



    </div>
</template>

<script>
    export default {
        data() {
            return {
                tableData: [],
                loading: false,
                subloading: false,
                height: null,
                adddialogVisible: false,
                formData: {
                    fwtimes: [],
                    user_value: '',
                    xw_options: [],
                    xwval: ''
                },
                eid: '',
                proloading: false,
                currentPage: 1,
                pagesize: 10,
                count: 0,
            }
        },
        created() {},
        mounted() {
            this.formData.fwtimes = this.gettime()
            this.getHeight()
            this.getxwxx()
        },
        methods: {
            getbegin(a) {
                this.getlist()
            },
            async getxwxx() {
                await axios.post("/admin/Behavior/getBehavior", {}, {
                        token: true
                    })
                    .then(response => {
                        this.formData.xw_options = response.data.data
                    })
                    .catch(error => {})
            },
            getHeight() {
                let that = this
                that.height = window.innerHeight - 250 + 'px'
                window.onresize = () => {
                    that.height = window.innerHeight - 250 + 'px'
                }
            },
            gettime() {
                let nowDate = new Date()
                let year = nowDate.getFullYear();
                let month = nowDate.getMonth() + 1;
                let day = nowDate.getDate();
                month = month > 9 ? month : '0' + month
                day = day > 9 ? day : '0' + day
                let endTime = `${year}-${month}-${day}`;
                let befDate = new Date(nowDate.getTime() - 7 * 24 * 3600 * 1000);
                let byear = befDate.getFullYear();
                let bmonth = befDate.getMonth() + 1;
                let bday = befDate.getDate();
                bmonth = bmonth > 9 ? bmonth : '0' + bmonth
                bday = bday > 9 ? bday : '0' + bday
                let startTime = `${byear}-${bmonth}-${bday}`;
                var fwtimes = [startTime, endTime]
                return fwtimes
            },
            getlist(id) {
                this.tableData = []
                this.proloading = true
                axios.post("/admin/BrowsingHistory/index", {
                        page: this.currentPage,
                        page_count: this.pagesize,
                        source: 1,
                        start_time: this.formData.fwtimes[0],
                        end_time: this.formData.fwtimes[1],
                        ip_province: '',
                        behavior_id: this.formData.xwval,
                        regular: '',
                        user_id: id ? id : this.formData.user_value,

                    }, {
                        token: true
                    })
                    .then(response => {
                        this.proloading = false
                        this.tableData = response.data.data.list
                        this.count = response.data.data.count
                    })
                    .catch(error => {})
            },
            handleSizeChange(val) {
                let that = this
                that.pagesize = val;
                that.getlist()
            },
            handleCurrentChange(val) {
                let that = this
                that.currentPage = val;
                that.getlist()
            },
        },
        watch: {

        }
    }
</script>

<style lang="scss" scoped>
    .add_tits {
        padding: 0 10px;
    }
</style>